exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-6e841490] {\n  margin-top: 0.56rem;\n}\n.box .title[data-v-6e841490] {\n  font-size: 0.4rem;\n}\n.box ul li[data-v-6e841490] {\n  font-size: 0.3733rem;\n  padding-top: 0.266rem;\n  padding-bottom: 0.266rem;\n}\n.box ul li .time[data-v-6e841490] {\n  float: right;\n}\n.box ul li .name[data-v-6e841490] {\n  display: inline-block;\n  width: 7.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.box ul .active *[data-v-6e841490] {\n  color: #027cfa;\n}\n", ""]);

// exports
